import React from 'react'
import PropTypes from 'prop-types'
import { Box } from '@mui/material'
import styles from './DrawerBadge.module.scss'

const VARIANT_MAP = {
  pass: styles.badgePass,
  success: styles.badgePass,
  fail: styles.badgeFail,
  error: styles.badgeFail,
  neutral: styles.badgeNeutral,
  info: styles.badgeInfo
}

const DrawerBadge = ({
  variant = 'neutral',
  children,
  className = ''
}) => {
  const variantClass = VARIANT_MAP[variant] || VARIANT_MAP.neutral

  return (
    <Box className={`${styles.badge} ${variantClass} ${className}`}>
      {children}
    </Box>
  )
}

DrawerBadge.propTypes = {
  variant: PropTypes.oneOf(['pass', 'success', 'fail', 'error', 'neutral', 'info']),
  children: PropTypes.node.isRequired,
  className: PropTypes.string
}

export default DrawerBadge
